import React from 'react';
import { Button } from '@/components/ui/button';
import { GitCompare, Check } from 'lucide-react';
import { Bot } from '@/types/Bot';

interface ComparisonButtonProps {
  bot: Bot;
  isInComparison: boolean;
  canAddMore: boolean;
  onAddToComparison: (bot: Bot) => void;
  onRemoveFromComparison: (botId: string) => void;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
}

export const ComparisonButton: React.FC<ComparisonButtonProps> = ({
  bot,
  isInComparison,
  canAddMore,
  onAddToComparison,
  onRemoveFromComparison,
  variant = 'outline',
  size = 'sm'
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering parent click events
    
    if (isInComparison) {
      onRemoveFromComparison(bot.id);
    } else {
      onAddToComparison(bot);
    }
  };

  const isDisabled = !isInComparison && !canAddMore;

  return (
    <Button
      variant={isInComparison ? 'default' : variant}
      size={size}
      onClick={handleClick}
      disabled={isDisabled}
      className={`transition-all duration-200 ${
        isInComparison 
          ? 'bg-primary text-primary-foreground' 
          : 'hover:bg-primary/10'
      }`}
    >
      {isInComparison ? (
        <>
          <Check className="w-4 h-4 mr-2" />
          In Comparison
        </>
      ) : (
        <>
          <GitCompare className="w-4 h-4 mr-2" />
          Compare
        </>
      )}
    </Button>
  );
};